<template>
    <div>
        <b-form-input
                v-bind:value="value"
                :type="type"
                :name="name"
                :class="{'is-invalid': errors.has(name) }"
                :placeholder="placeholder"
                :data-vv-as="alias"
                :disabled="disabled"
                v-validate="validate"
                @input="updateValue"

        ></b-form-input>

        <span v-show="errors.has(name)" class="help is-invalid">{{ errors.first(name) }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            value: String,
            name: String,
            validate: {
                type: [String, Object],
                default: ""
            },
            placeholder: String,
            type: {
                type: String,
                default: "text"
            },
            alias: {
                type: String,
                default: null
            },
            disabled: {
                type: [Boolean, Object],
                default: false
            }
        },
        inject: ['$validator'],
        methods: {
            updateValue(val) {
                this.$emit('input', val);
            },
            /*onValidate() {
                this.$validator.validateAll();
                if (this.errors.any()) {
                    bus.$emit('errors-changed', this.errors.errors)
                }
            },
            beforeDestroy() {
                bus.$off('validate', this.onValidate)
            }*/
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/snippets/form-input.vue